// components/FieldFactory.jsx
import React from 'react';
import { Autocomplete, TextField, Checkbox, FormControlLabel } from '@mui/material';
import { DateTimePicker } from '@mui/lab';

const FieldFactory = ({ field, value, onChange , lookupData, dynamicValues, unavailableUserIds , trucksList,disabled}) => {
  switch (field.componentType) {
    case 'Autocomplete':
    // 1. CASO DINAMICO: Combo Utenti (isAnaUserIdCombo === 1)
    if (field.isAnaUserIdCombo === 1) {
        const options = lookupData?.users || [];

        return (
        <Autocomplete
            fullWidth
            disabled={disabled}
            options={options}
            // Cerchiamo l'oggetto utente completo per mostrare il nome correttamente
            value={options.find(u => u.id === value) || null}
            getOptionLabel={(option) => option.fullName || ''}
            isOptionEqualToValue={(option, val) => option.id === val.id}
            getOptionDisabled={(option) => {
                if (!dynamicValues) return false;
                const isDuplicated = Object.keys(dynamicValues).some(fieldId => 
                    Number(fieldId) !== field.id && dynamicValues[fieldId] === option.id
                );
                const isUnavailable = unavailableUserIds && unavailableUserIds.includes(option.id);
                return isDuplicated || isUnavailable;
            }}
            
            onChange={(e, selected) => onChange(selected ? selected.id : null)}
            renderInput={(params) => <TextField {...params} label={field.name} required={field.isMandatory === 1}/>}
        />
        );
    }
    if (field.isAnaUserIdCombo === 2) {
        const options = trucksList || []; 
        return (
          <Autocomplete
              fullWidth
              disabled={disabled}
              options={options}
              value={options.find(t => Number(t.id) === Number(value)) || null}
              getOptionLabel={(option) => option.name || ''}
              isOptionEqualToValue={(option, val) => Number(option.id) === Number(val?.id || val)}
              onChange={(e, newValue) => onChange(newValue ? newValue.id : null)}
              renderInput={(params) => (
                <TextField 
                  {...params} 
                  label={field.name} 
                  required={field.isMandatory === 1}
                />
              )}
          />
        );
    }
    // 2. CASO STATICO: Valori predefiniti (es. "A,R" o "S,N")
    const staticOptions = field.eligibleValues ? field.eligibleValues.split(',') : [];
    return (
        <Autocomplete
          fullWidth 
          disabled={disabled}
          options={staticOptions}
          value={value === '' ? null : value}
          onChange={(e, newValue) => onChange(newValue)}
          renderInput={(params) => <TextField {...params} label={field.name} required={field.isMandatory === 1}/>}
        />
    );

    case 'Checkbox':
      return (
        <FormControlLabel
          disabled={disabled}
          control={<Checkbox checked={!!value} onChange={(e) => onChange(e.target.checked)} />}
          label={field.name}
        />
      );
    case 'DatePicker':
      return (
        <DateTimePicker
          disabled={disabled}
          label={field.name}
          value={value ? new Date(value) : null}
          onChange={(newValue) => onChange(newValue)}
          renderInput={(params) => <TextField {...params} fullWidth required={field.isMandatory === 1} />}
        />
      );
    case 'TextField':
    default:
      return (
        <TextField
          fullWidth
          disabled={disabled}
          label={field.name}
          multiline={field.anaFieldTypeId === 10} // Esempio logica TextArea
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          required={field.isMandatory === 1}
        />
      );
  }
};

export default FieldFactory;